import { Menu, Transition } from "@headlessui/react";
import Table from "../Table";
import { Link } from "react-router-dom";
import Pagination from "../plugins/Pagination/paginationBar";
import "../styles/customTable.scss";
import { BiSort } from "react-icons/bi";

import { v4 as uuidv4 } from "uuid";
import FilteredDataProvider from "../plugins/Filters";
import { statusStyles } from "../config/Transaction/statusTypes";
import { getDate } from "../helpers/dateConvertions";
import DetailedPageButtonLink from "../plugins/DetailedPageButtonLink";

class CategoryTable extends Table {
  tableSpacing: any = 50;
  tableColumnWidth: any = 250;
  finalSpacing: any = this.tableColumnWidth - this.tableSpacing;

  customSizes?: any = {
    "Date & Time": 200,
    Refund: 30,
    Source: 100,
    Amount: 100,
    "Transaction No": 100,
  };

  constructor(props: any) {
    super(props);
    this.stylingTableComp = "table-auto w-full text-[#141414] responsive";
    this.stylingTrComp = "p-[0.35em] border-b border-solid text-dark";
    this.stylingThComp =
      "p-[0.625em] text-end w-[958px] pb-2 pt-5 whitespace-pre";
    this.stylingTrBodyComp = "text-base ";
    this.stylingTheadComp =
      "text-base sticky top-0 z-50 bg-primary2 max-lg:hidden text-dark";
    this.stylingTBodyComp = "text-base ";
    this.stylingTdComp =
      "p-[0.625em] text-start lg:w-[220px] lg:table-cell flex justify-between z-0 font-normal";
  }

  /**
   *
   * @param cell
   * @condition if cell == refund return the menu for refunding
   * @returns
   */
  public override tdComp(cell: any) {
    if (cell?.column?.Header === "#") {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] whitespace-pre text-start lg:w-[180px] lg:table-cell flex justify-between font-medium"
        >
           <DetailedPageButtonLink orderId={cell.row.values._id} cell={cell} />
          {/* {cell.render("Cell")} */}
        </td>
      );
    }

    if (cell?.column?.Header === "Id") {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] whitespace-pre text-start !hidden lg:w-[180px] lg:table-cell justify-between font-medium"
        >
          {cell.render("Cell")}
        </td>
      );
    }


    if (cell?.column?.Header == "Date") {
      console.log('cell', cell)
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] text-start lg:w-[655px] whitespace-pre font-normal"
        >
          {getDate(cell.value)}
        </td>
      );
    }

    
    if (cell?.column?.Header == "Customer") {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] text-start lg:w-[655px] whitespace-pre font-normal"
        >
          {cell.render("Cell")}
        </td>
      );
    }

    if (cell?.column?.Header == "Total Revenue (AED)") {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] text-end lg:w-[655px] whitespace-pre font-normal"
        >
          {cell.render("Cell")}
        </td>
      );
    }

    
    if (cell?.column?.Header == "Status") {
      return (
        <td data-label={cell?.column?.Header} className={`${this.stylingTdComp}  lg:w-[${this.tableColumnWidth}px] relative`} {...cell.getCellProps()}>
        <div
          className={`lg:pr-4 lg:w-[${
            this.customSizes.hasOwnProperty(cell?.column?.Header) ? this.customSizes[`${cell?.column?.Header}`] : this.finalSpacing
          }px] text-left whitespace-pre max-lg:flex max-lg:justify-end`}
        >
          <div
            className={`my-1 py-1 px-4 flex justify-center items-center gap-2 ${statusStyles[cell.value.toUpperCase().split(' ').join('_')]?.bgColor} ${statusStyles[cell.value.toUpperCase().split(' ').join('_')]
              ?.textColor} rounded-lg w-fit whitespace-pre`}
          >
            <i className="pt-[2px]">{statusStyles[cell.value.toUpperCase().split(' ').join('_')]?.icon}</i>

            <p className={`text-sm pt-[2px]`}>{cell.render('Cell')}</p>
          </div>
          {/* {statusStyles.SETTLEMENT_FAILED} */}
          {/* {cell.render("Cell")} */}
        </div>
      </td>
      );
    } else {
      return (
        <td
          data-label={cell?.column?.Header}
          className="p-[0.625em] text-start lg:w-[655px] whitespace-pre font-normal"
        >
          {/* {cell.render("Cell")} */}
        </td>
      );
    }
  }

  public override thComp(column: any) {
    if (column?.Header === "#") {
      return (
        <th
          key={uuidv4()}
          className="pb-2 pt-5 p-[0.625em] text-start lg:w-[655px] whitespace-pre"
        >
          <div className="flex items-center justify-start gap-2">
            <span>{column.render("Header")}</span>{" "}
          </div>
        </th>
      );
    } else if (column?.Header === "Date") {
      return (
        <th
          key={uuidv4()}
          className="pb-2 pt-5 p-[0.625em] text-start lg:w-[655px] whitespace-pre"
        >
          <div className="flex items-center justify-start gap-2">
            <span>{column.render("Header")}</span>
          </div>
        </th>
      );
    } else if (column?.Header === "Status") {
      return (
        <th key={uuidv4()} className={`${this.stylingThComp} lg:w-0 `}>
          <div className="flex">
            <span>{column.render("Header")}</span>
          </div>
        </th>
      );
    } else if (column?.Header === "Id") {
      return (
        <th key={uuidv4()} className={`${this.stylingThComp} lg:w-0 !hidden`}>
          <div className="flex">
            <span>{column.render("Header")}</span>
          </div>
        </th>
      );
    } else if (column?.Header === "Customer") {
      return (
        <th key={uuidv4()} className={`${this.stylingThComp} lg:w-[180px] `}>
          <div className="flex items-end gap-2 justify-start">
            <span>{column.render("Header")}</span>{" "}
          </div>
        </th>
      );
    }else if (column?.Header === "Total Revenue (AED)") {
      return (
        <th key={uuidv4()} className={`${this.stylingThComp} lg:w-[180px] `}>
          <div className="flex items-end text-end gap-2 justify-start">
            <span>{column.render("Header")}</span>{" "}
          </div>
        </th>
      );
    } else {
      return (
        <th key={uuidv4()} className={this.stylingThComp}>
          {/* {column.render("Header")} */}
        </th>
      );
    }
  }

  public override tableComp() {
    return (
      <div className="w-full lg:px-8 px-4">
        {/* <div className="flex justify-between lg:flex-row flex-col items-start my-4 shadow-tableShadow gap-2 pr-10 p-2.5 max-lg:pr-2.5"> */}
        <FilteredDataProvider />
        {/* </div> */}

        <div className="shadow-tableShadow bg-primary2">
          <div className="lg:px-6 px-5 pb-4 w-full rounded mxs:h-[calc(100vh-257px)] h-[calc(124vh-257px)] max-lg:pr-1 main-table">
            <table
              {...this.getTableProps()}
              className={`${this.stylingTableComp} border-collapse border-spacing-3`}
            >
              {this.theadComp()}
              {/* <Divider className='w-full'/> */}

              {this.tBodyComp()}
            </table>
          </div>
        </div>

        <div className="mx-0">
          <Pagination initialLoad={true} jwtToken={this.props.jwtToken} />
        </div>
      </div>
    );
  }
}

export { CategoryTable };
